import { useScrollLock } from "shared/lib/browser/useScrollLock"
import { useRedux } from "shared/lib/useRedux"

export function useWindowScroll() {
  const { isScrollDisabled } = useRedux(({ scroll }) => ({
    isScrollDisabled: scroll.scrollPreventedBy.length > 0
  }))

  useScrollLock({
    enabled: isScrollDisabled,
    mounted: true,
    open: true
  })
}
